<template>
  <div>
    <div class="title" v-html="$t('keyboard.title')"></div>
    <div class="virtual-keyboard">
      <div class="main">
        <div class="title">
          Main
        </div>
        <div
          class="key"
          v-for="(mainKey, key) in mainKeys"
          :key="key"
          :class="{ selected: selectedKey === key }"
          :style="mainKey.style"
          @click="$emit('key-click', key)"
        >
          <div class="text" v-html="mainKey.text"></div>
        </div>
      </div>
      <div class="center-cluster">
        <div class="title">
          Center Cluster
        </div>
        <div
          class="key"
          v-for="(centerClusterKey, key) in centerClusterKeys"
          :key="key"
          :class="{ selected: selectedKey === key }"
          :style="centerClusterKey.style"
          @click="$emit('key-click', key)"
        >
          <div class="text" v-html="centerClusterKey.text"></div>
        </div>
      </div>
      <div class="numpad">
        <div class="title">
          Numpad
        </div>
        <div
          class="key"
          v-for="(numpadKey, key) in numpadKeys"
          :key="key"
          :class="{ selected: selectedKey === key }"
          :style="numpadKey.style"
          @click="$emit('key-click', key)"
        >
          <div class="text" v-html="numpadKey.text"></div>
        </div>
      </div>
      <div class="media">
        <div class="title">
          Media
        </div>
        <div
          class="key"
          v-for="(mediaKey, key) in mediaKeys"
          :key="key"
          :class="{ selected: selectedKey === key }"
          :style="mediaKey.style"
          @click="$emit('key-click', key)"
        >
          <div class="text" v-html="mediaKey.text"></div>
        </div>
      </div>
      <div class="function">
        <div class="title">
          Function
        </div>
        <template v-for="(fnKey, key) in fnKeys">
          <div
            class="key"
            :key="key"
            :class="{ selected: selectedKey === key }"
            :style="fnKey.style"
            @click="$emit('key-click', key)"
          >
            <div class="text" v-html="fnKey.text"></div>
          </div>
          <div class="desc" :key="'desc' + key">
            {{ $t("keyboard.macroDesc." + fnKey.desc) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  mainKeys,
  centerClusterKeys,
  numpadKeys,
  mediaKeys,
  fnKeys,
} from "./VirtualKeyboard65GameBoy";

export default {
  name: "CVirtualKeyboard65GameBoy",
  props: {
    selectedKey: String,
    layerNum: Number,
  },
  data() {
    return {
      mainKeys,
      centerClusterKeys,
      numpadKeys,
      mediaKeys,
      fnKeys,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
  },
};
</script>
<style lang="scss" scoped>
$key-width: 52px;
$key-margin: 6px;

.title {
  width: 100%;
  font-size: 18px;
  text-align: center;
}

.virtual-keyboard {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  > * {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 (10px - $key-margin) 0 10px;

    .title {
      width: 100%;
      font-size: 12px;
      color: $primary-color;
      text-align: left;
      margin: 20px 0 10px 0;
      white-space: nowrap;
    }

    .key {
      @include flex-center;
      width: $key-width;
      height: $key-width;
      margin: 0 $key-margin $key-margin 0;
      border: 1px solid #ffffff;
      cursor: pointer;

      .text {
        font-size: 24px;
        color: #ffffff;
        transform: scale(0.5);
        line-height: 1.1;
      }

      &.selected {
        border-color: $active-color;
        background: $active-color;
      }

      &:hover {
        border-color: $primary-color;
        background: $primary-color;
      }
    }

    .desc {
      width: ($key-width + $key-margin) * 6.3;
      line-height: $key-width / 2;
      font-size: 16px;
      text-align: left;
    }
  }

  .main {
    width: ($key-width + $key-margin) * 15;
  }

  .center-cluster {
    width: ($key-width + $key-margin) * 3;
  }

  .numpad {
    width: ($key-width + $key-margin) * 4;
  }
}
</style>
